import {
    Inject,
    Injectable,
    ComponentFactoryResolver,
    ViewContainerRef,
    Injector
} from '@angular/core';
import {
    INotificationOptions,
    INotificationPriority,
    OfNotificationService
} from 'src/app/modules/error-handler/error-handler-interfaces.service';
import { Notification } from 'src/app/modules/notification/notification';
import { NotificationDialogComponent } from 'src/app/modules/notification/notification-dialog/notification-dialog.component';
import { NotificationToastComponent } from 'src/app/modules/notification/notification-toast/notification-toast.component';

@Injectable({
    providedIn: 'root'
})
export class NotifierService implements OfNotificationService {
    private _rootViewContainer: ViewContainerRef;

    constructor (
        @Inject(ComponentFactoryResolver)
        private _factoryResolver: ComponentFactoryResolver
    ) {
        this._factoryResolver = _factoryResolver;
    }

    notify = (
        message: string,
        priority: INotificationPriority | number = 0,
        options: INotificationOptions = {}
    ) => {
        if (typeof priority === 'number') {
            if (priority < 0) {
                priority = 'silent';
            } else if (priority < 1) {
                priority = 'debug';
            } else if (priority <= 80) {
                priority = 'info';
            } else if (priority === 100) {
                priority = 'critical';
            }
        }

        const text = (options.viewOptions && options.viewOptions.text) || {
            body: message
        };

        const notification: Notification = {
            body: text.body,
            title: text.title
        };

        switch (priority) {
            case 'silent':
                break;
            case 'debug':
                console.log(message);
                console.log(options);
                break;
            case 'info':
            case 'minor':
            case 'moderate':
                this._showToast(notification);
                break;
            case 'major':
            case 'critical':
                this._showDialog(notification);
                break;
            default:
                console.log(message);
        }
    };

    public setRootViewContainerRef (viewContainerRef: ViewContainerRef): void {
        this._rootViewContainer = viewContainerRef;
    }

    public show (message: string): any {
        this.notify(message);
    }

    public showError (message: string): any {
        this.notify(message);
    }

    private _showDialog (notification: Notification): void {
        const factory = this._factoryResolver.resolveComponentFactory(
            NotificationDialogComponent
        );
        const injector = Injector.create({
            parent: this._rootViewContainer.injector,
            providers: [
                {
                    provide: 'notificationData',
                    useValue: notification
                }
            ]
        });
        const component = factory.create(injector);
        const ref = this._rootViewContainer.insert(component.hostView);
        component.instance.dismissed.subscribe(() => ref.destroy());
    }

    private _showToast (notification: Notification): void {
        const factory = this._factoryResolver.resolveComponentFactory(
            NotificationToastComponent
        );

        const injector = Injector.create({
            parent: this._rootViewContainer.injector,
            providers: [
                {
                    provide: 'notificationData',
                    useValue: notification
                }
            ]
        });
        const component = factory.create(injector);
        const ref = this._rootViewContainer.insert(component.hostView);
        ref.detectChanges();
        component.instance.dismissed.subscribe(() => ref.destroy());
    }
}
